import { getPlatformHeaderValue, isWeb } from 'shared/constants/platform';
import { displayVersion } from 'shared/utils/appVersionUtils';

type NativeWebSocketConstructor = new (
  address: string | URL,
  protocols: string | string[] | undefined,
  options: { headers: Record<string, string> | undefined },
) => WebSocket;

export const socketImplementation = (
  userAgent: string | undefined,
  varoSessionId: string,
) => {
  if (!isWeb && WebSocket) {
    const NativeWebSocket: NativeWebSocketConstructor = WebSocket;

    class GqlWebSocket extends NativeWebSocket {
      constructor(
        address: string | URL,
        protocols: string | string[] | undefined,
      ) {
        let headers: Record<string, string> | undefined;
        if (userAgent) {
          headers = {
            'user-agent': userAgent,
            'x-varo-session': varoSessionId,
          };
        }
        super(address, protocols, {
          headers,
        });
      }
    }

    return GqlWebSocket;
  }

  return undefined;
};

export const getSocketConnectionParams = (
  userAgent: string | undefined,
  idToken: string,
  varoSessionId: string,
) => {
  const timezoneOffset = new Date().getTimezoneOffset().toString();

  return {
    'x-varo-session': varoSessionId,
    mock: false,
    authorization: `Bearer ${idToken}`,
    'x-varo-tz-offset': timezoneOffset,
    'x-varo-platform': getPlatformHeaderValue(),
    'apollographql-client-version': displayVersion,
    'user-agent': userAgent,
  };
};
